import { render } from "./vendors.vue?vue&type=template&id=59852ac0&scoped=true"
import script from "./vendors.vue?vue&type=script&lang=js"
export * from "./vendors.vue?vue&type=script&lang=js"

import "./vendors.vue?vue&type=style&index=0&id=59852ac0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59852ac0"]])

export default __exports__